<template>
  <div class="tags" :class="sideTitle!==undefined&&'tags_sideTitle'">
    <div class="caption tags__title my-auto">Теги:</div>

    <v-menu
        v-model="menuOpen"
        :close-on-content-click="false"
        offset-y
        max-height="400"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="tags__tags-list">
          <chip v-for="(v, k) in localTags" :key="k" class="tags__tag text-no-wrap" :color="v.tag.color"
                @click="tag = v"><span :style="`color:${$tools.getContrastColor(v.tag.color)}`">{{ v.tag.name }}</span>
            <v-icon x-small class="ml-1">mdi-cog-outline</v-icon>
          </chip>
          <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              text
              class="tags__add-btn"
              :loading="loadState.isLoading"
              @click="items.length===0 ? load() : null"
          >
            <tooltip right>
              <v-icon>mdi-plus</v-icon>
              <template v-slot:content>
                Добавить тег
              </template>
            </tooltip>
          </v-btn>
        </div>
      </template>
      <v-card>
        <v-text-field
            v-model="searchQuery"
            placeholder="Поиск..."
            solo
            flat
            hide-details
            class="search-field"
            @input="filterItems"
        ></v-text-field>
        <v-list>
          <v-list-item
              v-for="(item, index) in filteredItems"
              :key="index"
              @click="tag = item"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>

    <tag-link-settings :tag.sync="tag" @update="tagUpdate" @add="(v)=>{localTags.push(v)}"
                       @delete="(id)=>{localTags = localTags.filter(v=>v.id!==id)}" :entityId="entityId"
                       :entityType="entityType"/>
  </div>
</template>

<script>
import State from "@/plugins/state";
import moment from "moment";
import TagLinkSettings from "@/views/Tag/components/TagLinkSettings.vue";
import Chip from "@/componentsV2/base/Chip.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";

import {Entity_MedPlan, Entity_Tag, Entity_TagLink, Entity_User} from "../../../../EntityStoreCacheService";

export default {
  components: {TagLinkSettings, Chip, Tooltip},
  props: ['tags', 'entityId', 'entityType', 'sideTitle'],
  data: () => ({
    localTags: [],
    // localEntityId: null,
    menuOpen: false,
    searchQuery: null,
    loadState: new State(),
    items: [],
    filteredItems: [],
    tag: null
  }),
  mounted() {
    if (this.tags !== undefined) {
      this.localTags = this.tags.filter(i => i.status !== 'inactive');
    } else {
      this.tagLinksLoad();
    }

    // if (this.entityId !==undefined)
    //   this.localEntityId = this.entityId

  },
  watch: {
    entityId(v) {
      if (v !== undefined)
        this.tagLinksLoad();
    }
  },
  methods: {
    tagLinksLoad() {
      let rb = new Entity_TagLink()
          .selects(Entity_TagLink.id)
          .selects(Entity_TagLink.endDate)
          .selects(Entity_TagLink.startDate)
          .selects(Entity_TagLink.status)
          .selects([Entity_TagLink.tag, Entity_Tag.id].join('.'))
          .selects([Entity_TagLink.tag, Entity_Tag.name].join('.'))
          .selects([Entity_TagLink.tag, Entity_Tag.color].join('.'))

      if (this.entityType === 'user')
        rb.filterAnd([Entity_TagLink.entity, Entity_TagLink.user, Entity_User.id].join('.') + '=?', this.entityId);

      if (this.entityType === 'medPlan')
        rb.filterAnd([Entity_TagLink.entity, Entity_TagLink.medPlan, Entity_MedPlan.id].join('.') + '=?', this.entityId);

      rb.filterAnd([Entity_TagLink.entity, Entity_TagLink.status].join('.') + '=?', 'active');
      rb.page(1).onPage(1000)
          .addStateCallback((v) => this.loadState.setRequestBuilderState(v))
          .request((v) => {
            this.localTags = v.items;
            // this.localEntityId = user?.id;
          }, (e) => {
            console.error(e.response.data.message);
            this.loadState.stateError(e)
          })
    },
    load() {
      new Entity_Tag()
          .selects(Entity_Tag.id)
          .selects(Entity_Tag.name)
          .selects(Entity_Tag.color)
          .selects(Entity_Tag.durationDays)
          .order(Entity_Tag.name, true)
          .filterAnd([Entity_Tag.entity, Entity_Tag.type].join('.') + ' =?', this.entityType)
          .page(1).onPage(1000)
          .addStateCallback((v) => this.loadState.setRequestBuilderState(v))
          .request((v) => {
            this.items = [];
            v.items.forEach(item => {
              let obj = {
                name: item.name,
                id: item.id,
                color: item.color,
                startDate: moment(new Date()).format('YYYY-MM-DD'),
                endDate: item.durationDays !== null ? moment(new Date()).add(item.durationDays, 'day').format('YYYY-MM-DD') : null
              }
              this.items.push(obj);
            });
            this.filteredItems = this.items;
          }, (e) => {
            console.error(e.response.data.message);
            this.loadState.stateError(e)
          })
    },
    filterItems() {
      if (!this.searchQuery) {
        this.filteredItems = this.items;
        return;
      }
      this.filteredItems = this.items.filter(item =>
          item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    tagUpdate(v) {
      const tag = this.localTags.find(tag => tag.id === v.id);
      if (tag) {
        tag.startDate = v.startDate,
            tag.endDate = v.endDate
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tags {
  &__title {
    margin-bottom: 5px;
  }

  &__tags-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px;
  }

  &_sideTitle {
    display: flex;
    gap: 0 10px;
  }

  &_sideTitle #{&}__title {
    padding-top: 3px;
    margin-bottom: 0;
    display: flex;
  }

  &__add-btn {
    padding: 0 !important;
    height: auto !important;
  }

  &__tag {
    cursor: pointer;
  }
}
</style>